import { render, staticRenderFns } from "./scdcdjcf1.vue?vue&type=template&id=70b97c77&scoped=true&"
import script from "./scdcdjcf1.vue?vue&type=script&lang=js&"
export * from "./scdcdjcf1.vue?vue&type=script&lang=js&"
import style0 from "./scdcdjcf1.vue?vue&type=style&index=0&id=70b97c77&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b97c77",
  null
  
)

export default component.exports